var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.5 9.5 9-5.5M12 12.5 21 7m-9 5.5L3 7m9 5.5v10M2 9.718v4.564c0 .991 0 1.487.142 1.932a3 3 0 0 0 .605 1.068c.309.351.734.606 1.583 1.116l5.2 3.12c.898.539 1.347.808 1.827.914a3 3 0 0 0 1.287 0c.479-.106.928-.375 1.826-.914l5.2-3.12c.85-.51 1.274-.765 1.583-1.116a3 3 0 0 0 .605-1.068c.142-.445.142-.94.142-1.932V9.718c0-.991 0-1.487-.142-1.932a3 3 0 0 0-.605-1.068c-.309-.351-.734-.606-1.583-1.116l-5.2-3.12c-.898-.539-1.347-.808-1.827-.914a3 3 0 0 0-1.287 0c-.479.106-.928.375-1.826.914l-5.2 3.12c-.85.51-1.274.765-1.583 1.116a3 3 0 0 0-.605 1.068C2 8.23 2 8.726 2 9.718"
  })));
};
export default SvgBox;